<template>
  <MTableRow
    v-if="showNestedTable"
    v-bind="$props"
    :is-nested="true"
    class="m-table-nested-row"
  >
    <slot />
  </MTableRow>
</template>

<script>
  import MTableRow from 'components/Data/Tables/MTable/MTableRow';

  export default {
    name: 'MTableNestedRow',
    components: {MTableRow},
    props: {
      index: {
        type: Number,
        required: true
      },
      colorFunction: {
        type: Function,
        default: null
      },
      tableRow: {
        type: Object,
        default: Object
      },
      enabledKey: {
        type: String,
        default: null
      },
      uniqueKeyAttr: {
        type: String,
        default: 'id'
      },
      openedRowsKeys: {
        type: Array,
        default: Array
      },
      openedNestedRows: {
        type: Array,
        default: Array
      },
      selected: {
        type: Number,
        default: undefined
      },

      // this prop is unique value from table may be id or other unique value. This is why we accept Number and String
      nestedParentId: {
        type: [String, Number],
        required: true
      }
    },
    computed: {
      showNestedTable () {
        return this.openedNestedRows.includes(this.nestedParentId);
      }
    }
  };
</script>
